
const fontFamilyBase = [
  '-apple-system',
  '"BlinkMacSystemFont"',
  '"Segoe UI"',
  '"Roboto"',
  '"Helvetica Neue"',
  '"Arial"',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
]

// Used for headings, attention-grabbing titles and key elements that require a larger sizing
export const RhetorikFontFamily = ['"Rhetorik Sans"', ...fontFamilyBase].join(',')
export const RhetorikLightFontFamily = ['"Rhetorik Light"', ...fontFamilyBase].join(',')
// Used for body text, captions, and smaller elements that require a more readable font
export const InterVariableFontFamily = ['"Inter Variable"', ...fontFamilyBase].join(',')

export const BACKBONE_SAND = '#F2F4EB'
export const DARK_BACKBONE_SAND = '#DADFCA'
export const PAPER_WHITE = '#FEFDFA'
export const WHITE = '#FFFFFF'
export const DEEP_SPACE_BLACK = '#22292E'
export const MEDITERRANEAN_BLUE = '#4BAABB'
export const CONTRAST_BLUE = '#3F9CAD'
export const DARK_ORANGE = '#E06E49'
export const CONTRAST_ORANGE = '#B84B28'
export const EVERYDAY_PEN_PURPLE = '#7B61FF'
export const CONTRAST_BACKBONE_SAND = '#EAEDDF'
export const CONTRAST_PAPER_WHITE = '#DBDBDB'
export const DARK_CONTRAST_BACKBONE_SAND = '#E6E6DD'
export const CAUTION_RED = '#FDF4F1'
export const ACTIVATED_GREEN = '#F5F9F4'
export const OCEAN_BLUE = '#148BD1'
/** Border of a selected option card. Sits between BLUE_700 and BLUE_800, outside the scale. */
export const SELECTED_BLUE = '#65B3EC'

export const YES_GREEN = '#6AC58A'
export const NO_RED = '#E85E5E'

export const TRANSPARENT = 'transparent'

// Redesigned colors
export const CORAL_100 = '#FFF5F3'
export const CORAL_200 = '#FFE8E3'
export const CORAL_300 = '#FFD3C7'
export const CORAL_400 = '#FFBBAA'
export const CORAL_500 = '#FF967D'
export const CORAL_600 = '#FF6E51'
export const CORAL_700 = '#DD5E46'
export const CORAL_800 = '#C0523D'
export const CORAL_900 = '#8A3F2F'
export const CORAL_1000 = '#532F27'
export const CORAL_1100 = '#2A1A17'
export const GREEN_100 = '#F1F8EF'
export const GREEN_200 = '#E2EEE1'
export const GREEN_300 = '#D6E8D3'
export const GREEN_400 = '#C3DEC0'
export const GREEN_500 = '#98BD93'
export const GREEN_600 = '#76A470'
export const GREEN_700 = '#5C7E58'
export const GREEN_800 = '#4B6647'
export const GREEN_900 = '#394D37'
export const GREEN_1000 = '#2A3229'
export const GREEN_1100 = '#1E221E'
export const YELLOW_100 = '#FFF9E6'
export const YELLOW_200 = '#FFF4DA'
export const YELLOW_300 = '#F1E9C7'
export const YELLOW_400 = '#E2D3A2'
export const YELLOW_500 = '#C8AF73'
export const YELLOW_600 = '#B29A56'
export const YELLOW_700 = '#A68F4F'
export const YELLOW_800 = '#947D42'
export const YELLOW_900 = '#776334'
export const YELLOW_1000 = '#493C1D'
export const YELLOW_1100 = '#241D0F'
export const GRAY_100 = '#FEFEFE'
export const GRAY_200 = '#FBFBFB'
export const GRAY_300 = '#EFF0F0'
export const GRAY_400 = '#DCDDDE'
export const GRAY_500 = '#C1C2C3'
export const GRAY_600 = '#9D9FA1'
export const GRAY_700 = '#727578'
export const GRAY_800 = '#404448'
export const GRAY_900 = '#252A2E'
export const GRAY_1000 = '#13181D'
export const GRAY_1100 = '#07080A'
export const GRAY_TEXT = '#6E6E6E'
export const GRAY_BORDER = '#EDEDED'
export const BEIGE_100 = '#FEFEFD'
export const BEIGE_200 = '#FDFDFC'
export const BEIGE_300 = '#FCFBF9'
export const BEIGE_400 = '#FAF8F4'
export const BEIGE_500 = '#F9F6F1'
export const BEIGE_600 = '#F7F3ED'
export const BEIGE_700 = '#EAE4D7'
export const BEIGE_800 = '#D6D0C2'
export const BEIGE_900 = '#BCB39F'
export const BEIGE_1000 = '#595646'
export const BEIGE_1100 = '#22201C'
export const BLUE_100 = '#F8FCFF'
export const BLUE_200 = '#F0F9FF'
export const BLUE_300 = '#E1F3FF'
export const BLUE_400 = '#C9EAFE'
export const BLUE_500 = '#B2E1FD'
export const BLUE_600 = '#97D2FB'
export const BLUE_700 = '#7DBFEF'
export const BLUE_800 = '#5AA6E0'
export const BLUE_900 = '#3F8FCF'
export const BLUE_1000 = '#2B6C95'
export const BLUE_1100 = '#212C35'
export const BLACK_TEXT = '#000000'

// Success/Error state colors
export const SUCCESS_GREEN_500 = '#22c55e'
export const SUCCESS_GREEN_100 = '#dcfce7'
export const ERROR_RED_500 = '#ef4444'
export const ERROR_RED_600 = '#dc2626'
export const ERROR_RED_100 = '#fee2e2'
export const GRAY_50 = '#f9fafb'

// Redesigned box shadow
export const BOX_SHADOW_BOTTOM = '0 .2rem .2rem rgba(19, 24, 29, 0.04)'
export const BOX_SHADOW_XS = '0px 1px 4px 0px rgba(19, 24, 29, 0.06)'
export const BOX_SHADOW_SM = '0px 1px 4px 0px rgba(19, 24, 29, 0.10)'
export const BOX_SHADOW_MD = '0px 2px 8px 0px rgba(19, 24, 29, 0.10)'
export const BOX_SHADOW_LG = '0px 4px 16px 0px rgba(19, 24, 29, 0.10)'
export const BOX_SHADOW_XL = '0px 8px 24px 0px rgba(19, 24, 29, 0.10)'
export const BOX_SHADOW_2XL = '0px 24px 48px 0px rgba(19, 24, 29, 0.10)'
export const BOX_SHADOW_3XL = '0px 32px 64px 0px rgba(19, 24, 29, 0.10)'

// Media queries
export const MOBILE_VIEW_WIDTH_QUERY = '(max-width:800px)'
export const MOBILE_VIEW_HEIGHT_QUERY = '(max-height:767px)'

export const TABLET_VIEW_QUERY = '(max-width:920px)'
